import { DELETE, GET, POST, PUT } from '../../../redux/middleware/types'
import deliveryRequest from '../../../services/api/deliveryRequest'
import { DeliverySubscription } from '../../../types/deliverySubscription/DeliverySubscription'
import { Delivery } from '../../../types/deliverySubscription/Delivery'
import { Contract } from '../../../types/contract/Contract'

const endpoints = {
  list: (contractId: Contract['id']) => `/contracts/${contractId}/delivery-subscriptions/`,
  detail: (contractId: Contract['id'], id: DeliverySubscription['id']) =>
    `/contracts/${contractId}/delivery-subscriptions/${id}`,
  deliver: (contractId: Contract['id'], id: DeliverySubscription['id']) =>
    `/contracts/${contractId}/delivery-subscriptions/${id}/deliver`,
  deliveries: (contractId: Contract['id'], id: DeliverySubscription['id']) =>
    `/contracts/${contractId}/delivery-subscriptions/${id}`
}

export const fetchDeliverySubscriptions = (contractId: Contract['id']) =>
  deliveryRequest<DeliverySubscription[]>({ method: GET, url: endpoints.list(contractId) })

export const createDeliverySubscription = (contractId: Contract['id'], data: DeliverySubscription) =>
  deliveryRequest<DeliverySubscription>({ method: POST, url: endpoints.list(contractId), data })

export const updateDeliverySubscription = (
  contractId: Contract['id'],
  id: DeliverySubscription['id'],
  data: DeliverySubscription
) => deliveryRequest<DeliverySubscription>({ method: PUT, url: endpoints.detail(contractId, id), data })

export const deleteDeliverySubscription = (contractId: Contract['id'], id: DeliverySubscription['id']) =>
  deliveryRequest<DeliverySubscription>({ method: DELETE, url: endpoints.detail(contractId, id) })

export const sendDeliverySubscription = (contractId: Contract['id'], id: DeliverySubscription['id']) =>
  deliveryRequest<DeliverySubscription>({ method: POST, url: endpoints.deliver(contractId, id) })

export const fetchDeliveries = (contractId: Contract['id'], id: DeliverySubscription['id']) =>
  deliveryRequest<Delivery[]>({ method: GET, url: endpoints.deliveries(contractId, id) })

export const fetchDeliveryByUuid = (uuid: string) =>
  deliveryRequest<Delivery>({ method: GET, url: `/deliveries/${uuid}` })

export const downloadDelivery = (uuid: string) =>
  deliveryRequest<BlobPart>({ method: GET, url: `/deliveries/${uuid}/download`, responseType: 'blob' })
